type OrderStatusViewProps = {
    shippingData: any[];
};

const OrderStatusView = (props: OrderStatusViewProps) => {
    const columns = [
        "LDS",
        "ETD",
        "BL",
        "ETA",
        "Release",
        "Req DO",
        "DO Apv",
        "ATA",
        "Receipt",
        "Inspect",
        "Process",
        "Delivered",
    ];

    function isDate1BeforeDate2(date1: string, date2: string): boolean {
        return new Date(date1) < new Date(date2);
    }

    function isDateOlderThanToday(dateString: string): boolean {
        const inputDate = new Date(dateString);
        const today = new Date();

        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return inputDate < today;
    }

    function isDateInTwoDays(dateString: string): boolean {
        const inputDate = new Date(dateString);
        const today = new Date();
        const twoDaysFromNow = new Date();

        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        twoDaysFromNow.setHours(0, 0, 0, 0);
        twoDaysFromNow.setDate(today.getDate() + 2);

        return inputDate.getTime() === twoDaysFromNow.getTime();
    }

    const getETAColor = function (date: string, ataDate: string | null) {
        if (isDateOlderThanToday(date) && !ataDate) {
            return "#f57242ff";
        } else if (isDateInTwoDays(date)) {
            return "#f5f108ff";
        } else {
            return "#1cf508ff";
        }
    };

    const getShipArrivedDateColor = function (
        etaDate: string,
        ataDate: string
    ) {
        if (isDate1BeforeDate2(etaDate, ataDate)) {
            return "#f57242ff";
        } else {
            return "#1cf508ff";
        }
    };

    const formatDate = function (dateString: string | null) {
        if (!dateString) {
            return null;
        } else {
            const date = new Date(dateString);
            const options: Intl.DateTimeFormatOptions = {
                month: "short",
                day: "numeric",
            };

            return date.toLocaleDateString("en-US", options);
        }
    };

    return (
        <table
            className="table table-hover mb-0"
            style={{
                borderRight: "1px solid #efefef",
            }}
        >
            <thead
                style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#0d6efd",
                    color: "white",
                    zIndex: 10,
                }}
            >
                <tr>
                    {columns.map((column: string, idx) => (
                        <th
                            key={idx}
                            className="fw-semibold text-uppercase text-center"
                            style={{
                                fontSize: "0.7rem",
                                color: "#6c757d",
                                padding: "0.6rem",
                                borderBottom: "2px solid #dee2e6",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {column}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody style={{ marginBottom: 50 }}>
                {props.shippingData.map((row: any, idx) => (
                    <tr
                        key={idx}
                        style={{
                            borderBottom: "1px solid #f0f0f0",
                            height: 50,
                        }}
                    >
                        {columns.map((column, dateIdx) => (
                            <td
                                key={dateIdx}
                                className="text-center"
                                style={{
                                    padding: "0.5rem",
                                    maxWidth: 10,
                                }}
                            >
                                {column == "LDS" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.latest_day_of_shipment)}
                                    </span>
                                )}
                                {column == "ETD" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.latest_day_of_shipment)}
                                    </span>
                                )}
                                {column == "BL" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.date_order)}
                                    </span>
                                )}
                                {column == "ETA" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: getETAColor(
                                                row.date_planned,
                                                row.shipped_date
                                            ),
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.date_planned)}
                                    </span>
                                )}
                                {column == "ATA" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor:
                                                getShipArrivedDateColor(
                                                    row.date_planned,
                                                    row.shipped_date
                                                ),
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.shipped_date)}
                                    </span>
                                )}
                                {column == "Receipt" && !row.is_dropship && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.effective_date)}
                                    </span>
                                )}
                                {column == "Inspect" && row.is_dropship && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(
                                            row.dropship_inspection_date
                                        )}
                                    </span>
                                )}
                                {column == "Process" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.clearance_start_date)}
                                    </span>
                                )}
                                {column == "Delivered" && row.is_dropship && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.dropship_delivery_date)}
                                    </span>
                                )}
                                {column == "Release" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.original_bl_date)}
                                    </span>
                                )}
                                {column == "REQ DO" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor: "#1cf508ff",
                                            fontWeight: "700",
                                            fontSize: "0.7rem",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.request_do_date)}
                                    </span>
                                )}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
export default OrderStatusView;
